import { CheckboxCard } from '@design-system';

import { Image } from '../../../Image';
import { ProductPrice } from '../../../ProductPrice/ProductPrice';
import { CurrencyCode } from '../types';

export interface FrameStyleOptionProps {
  groupName: string;
  title: string;
  description?: string;
  images: Array<{ src: string; alt: string }>;
  checked: boolean;
  /** Price difference versus the currently selected style (0 → no suffix). */
  priceDelta: number;
  currencyCode?: CurrencyCode;
  isFloat?: boolean;
  recommendedLabel?: string | null;
  onSelect: () => void;
}

export const FrameStyleOption = ({
  checked,
  currencyCode,
  description,
  groupName,
  images,
  isFloat = false,
  onSelect,
  priceDelta,
  recommendedLabel,
  title,
}: FrameStyleOptionProps) => {
  const id = `${groupName}-${encodeURIComponent(title)}`;
  const showPrice = !checked && priceDelta !== 0;

  return (
    <CheckboxCard
      checked={checked}
      description={description}
      id={id}
      label={title}
      name={groupName}
      onChange={onSelect}
      slot={
        <div className="grid w-full grid-cols-2 gap-3">
          {images.slice(0, 2).map((image) => (
            <Image
              key={image.src}
              alt={image.alt}
              src={image.src}
              width={384}
            />
          ))}
        </div>
      }
      slotVisibleOnChecked
      suffix={
        showPrice ? (
          <ProductPrice
            currencyCode={currencyCode}
            isFloat={isFloat}
            prefix={priceDelta >= 0 ? '+' : '-'}
            price={Math.abs(priceDelta)}
            skipConvertCurrency={!!currencyCode}
            skipTaxCalculation
          />
        ) : undefined
      }
      tag={recommendedLabel ?? undefined}
      type="radio"
      value={title}
    />
  );
};
